import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { ToastContext } from 'components/toasts/ToastContext';
import { SnackbarNotification } from 'aura-react-components';
let idCounter = 0;
export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);
    const showToast = useCallback((message, severity, duration = 5000) => {
        const id = idCounter++;
        const toast = { id, message, severity, duration };
        setToasts((prev) => [...prev, toast]);
    }, []);
    const removeToast = useCallback((id) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, []);
    const toastValue = useMemo(() => ({ toasts, showToast, removeToast }), [toasts, showToast, removeToast]);
    return (_jsxs(ToastContext.Provider, { value: toastValue, children: [children, toasts.map((toast) => (_jsx(SnackbarNotification, { id: toast.id.toString(), message: toast.message, severity: toast.severity, open: true, onClose: () => removeToast(toast.id), duration: toast.duration }, toast.id)))] }));
};
